import React, { memo, useCallback } from 'react';
import { Checkbox, TableRow, TableCell } from 'semantic-ui-react';
import { Text, TextInput } from '@cuemath/web-comps';

import { MIN_WEIGHT, MAX_WEIGHT } from '../../constants';
import { CompactInputWrapper } from './reviewer-row-styled';

const ReviewerRow = memo(({ reviewer, disabled, onUpdate }) => {
  const handleWeightChange = useCallback(
    value => {
      const parsed = value === '' ? '' : parseInt(value, 10);
      onUpdate(reviewer.id, { weight: Number.isNaN(parsed) ? '' : parsed });
    },
    [reviewer.id, onUpdate],
  );

  const handleLeaveToggle = useCallback(
    (_, { checked }) => onUpdate(reviewer.id, { on_leave: checked }),
    [reviewer.id, onUpdate],
  );

  return (
    <TableRow>
      <TableCell width={6}>
        <Text variant="body2">{reviewer.id}</Text>
      </TableCell>
      <TableCell width={6}>
        <Text variant="body2">{reviewer.name}</Text>
      </TableCell>
      <TableCell width={2}>
        <CompactInputWrapper>
          <TextInput
            name={`reviewer-weight-${reviewer.id}`}
            type="number"
            minNumber={String(MIN_WEIGHT)}
            maxNumber={String(MAX_WEIGHT)}
            value={reviewer.weight}
            onChange={handleWeightChange}
            disable={disabled}
          />
        </CompactInputWrapper>
      </TableCell>
      <TableCell width={2} textAlign="center">
        <Checkbox
          toggle
          checked={!!reviewer.on_leave}
          onChange={handleLeaveToggle}
          disabled={disabled}
        />
      </TableCell>
    </TableRow>
  );
});

export default ReviewerRow;
